import { render, staticRenderFns } from "./novaUpload.vue?vue&type=template&id=442878e7&scoped=true&"
import script from "./novaUpload.vue?vue&type=script&lang=ts&"
export * from "./novaUpload.vue?vue&type=script&lang=ts&"
import style0 from "./novaUpload.vue?vue&type=style&index=0&id=442878e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442878e7",
  null
  
)

export default component.exports